export const ERROR = 'error'
export const INFO = 'info'
export const SUCCESS = 'success'
